// Wrap the underlying deferred so the call site keeps using `.promise()` like a
// normal Request, but rejects on GraphQL `errors` and unwraps `data.<field>` on
// success.
//
// IMPORTANT: ajaxRequestV2 returns a jQuery-style deferred (simply-deferred),
// whose `.then()` predates Promises/A+ -- an exception thrown inside a `.then`
// callback is NOT turned into a rejection, it is silently swallowed. On top of
// that, GraphQL always answers HTTP 200 even when the body carries `errors`, so
// the deferred always resolves. We therefore bridge to a native Promise and call
// `reject` explicitly, so `await` / `.catch` at the call sites work.
export default function unwrapGraphQL<T>(call: any, dataField: string) {
    return {
        promise: (): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                call.promise().then(
                    (response: any) => {
                        if (response?.errors?.length) {
                            reject(new Error(response.errors.map((e: any) => e.message).join('; ')))
                            return
                        }
                        resolve(response?.data?.[dataField])
                    },
                    // HTTP-level failure (4xx/5xx) -- already handled by
                    // ajaxRequestV2's autoError, but propagate so the caller's
                    // catch still fires.
                    (err: any) => {
                        reject(err)
                    },
                )
            })
        },
    }
}
